module.exports = __webpack_public_path__ + "static/1-3f77260bd332aae701a08721c5472fb7.jpeg";